// Демо-формы подсказок.

import urls from "../urls";
import AddressSuggestions from "./address";
import AddressSuggestionsGranular from "./address-granular";
import PartySuggestions from "./party";
import BankSuggestions from "./bank";
import NameSuggestions from "./name";
import NameSuggestionsGranular from "./name-granular";
import EmailSuggestions from "./email";
import OutwardSuggestions from "./outward";

const { settings } = window.DA;

const serviceUrl = urls.api.demo.getUrl();
const token = settings.API_KEY;

AddressSuggestions(serviceUrl, token, "SUG_DEMO_FORM_ADDRESS");
PartySuggestions(serviceUrl, token);
AddressSuggestionsGranular(serviceUrl, token);
BankSuggestions(serviceUrl, token);
NameSuggestions(serviceUrl, token);
NameSuggestionsGranular(serviceUrl, token);
EmailSuggestions(serviceUrl, token);
OutwardSuggestions(serviceUrl, token);
